import type { GraphNode, Scope } from "./GraphTypes";


export interface CommandElement {
  type: string;
  elements: NodeElement[];
  attributeId?: undefined;
  relationshipId?: string;
  relationshipReverse?: boolean;
  scope?: Scope;
}

export interface AttributeElement {
  type: "attribute" | "for";
  attributeId: string;
  relationshipId?: string;
  relationshipReverse?: boolean;
  scope?: Scope;
  debug?: {
    description: string;
  };
}

export interface ValueElement {
  type: "value";
  attributeId?: undefined;
  value: any;
  special?: "EndOfTime" | "BeginningOfTime" | "CurrentDate";
}

export interface LiteralElement {
  type: "uncertain" | "empty";
  attributeId?: undefined;
}

export type NodeElement = (AttributeElement | CommandElement | ValueElement | LiteralElement) & {
  elements?: NodeElement[];
};

export const iterateElements = (
  elements: NodeElement[] | undefined,
  callback: (element: NodeElement) => undefined | false,
) => {
  if (!elements) {
    return;
  }
  for (const element of elements) {
    if (Array.isArray(element)) {
      if (iterateElements(element, callback) === false) {
        return false;
      }
      continue;
    }

    if (callback(element) === false) {
      return false;
    }
    if ("elements" in element) {
      if (iterateElements(element.elements, callback)) {
        return false;
      }
    }
  }
};

export const iterateNodeElements = (
  node: GraphNode,
  callback: (element: NodeElement) => undefined | false,
): undefined | false => {
  if (node.conditions) {
    if (iterateElements(node.conditions as NodeElement[], callback) === false) {
      return false;
    }
  }
  if (node.value) {
    const valueElements = Array.isArray(node.value) ? node.value : [node.value];
    if (iterateElements(valueElements, callback) === false) {
      return false;
    }
  }
  if (node.otherwise) {
    if (iterateElements([node.otherwise], callback) === false) {
      return false;
    }
  }
  if (node.rows) {
    for (const row of node.rows) {
      if (iterateElements(row, callback) === false) {
        return false;
      }
    }
  }
  if (node.inferred?.conditions) {
    if (iterateElements(node.inferred.conditions, callback) === false) {
      return false;
    }
  }
  return undefined;
};